module.exports = __webpack_public_path__ + "./ChingYaPhoto_7a83b6ace670bdcafcd95f25acc563a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/ChingYaPhoto.png
// module id = 523
// module chunks = 0